import React from 'react';
import { Form, Icon, Input, Radio, Select } from 'antd';
import Signature from "./Signature";

const { Option } = Select;

export default class extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const props = this.props;
    const showForEmail = !(props.consentMethodType === 'EmailRegainedCapacity' && !props.token);

    return (
      <div className="form-group">
        <div className="form-group-details">
          <h4>Consent Process - REGAINED CAPACITY CONSENT FORM</h4>

          {props.siteID && <h5>Site ID: <b>{props.siteID}</b></h5>}
          {props.userID && <h5>User ID: <b>{props.userID}</b></h5>}
          <h5>Subject ID: <b>{props.subjectID}</b></h5>
        </div>

        {props.has_randomization_platform_step_3_patient_regained_capacity ? <div
            dangerouslySetInnerHTML={{__html: props.randomization_platform_step_3_patient_regained_capacity_content}}/> :
          <div style={{textAlign: 'justify'}}>
            <p>Because your illness or injury made it impossible for you to participate fully in the informed consent process, the consent was obtained from your legally authorized representative (substitute decision-maker) on your behalf. Your substitute decision-maker believed you would have wished to participate in this research if you had been able to express your own opinion at the beginning of the research project.</p>
            <p>Informed consent is essential throughout a research project. This means in your situation, you are now being given the opportunity to agree or disagree with the decision made by your substitute decision-maker for you to participate. Any information that has already been obtained, when the researchers were acting on your substitute decision maker’s consent for your involvement, will remain part of the study information, but it is now your choice whether to continue.</p>
            <p>Your signature on this form indicates that you have understood to your satisfaction the information regarding your participation in the research project and agree to participate as a subject. In no way does this waive your legal rights nor release the investigators, or involved institutions from their legal and professional responsibilities. You are free to withdraw from the study at any time without jeopardizing your health care. If you have further questions concerning matters related to this research, please contact <b>Dr. Dar Dowlatshahi MD PhD FRCPC 613-798-5555 x 16449 </b></p>
            <p>If you have any questions concerning your rights as a possible participant in this research, please contact <b>Chair of the Sunnybrook Research Ethics Board at (416) 480-6100 ext. 88144.</b></p>
          </div>}
        <p><strong>Server Date (UTC): {props.consentDate || props.date}</strong></p>
        <p><strong>Consent Type: {props.consentPersonType}</strong></p>
        <p><strong>Consent Method: {props.consentMethodType}</strong></p>
        <p>&nbsp;</p>

        <div style={{ textAlign: 'left' }}>

          {showForEmail && <div>
            <p>Please check the appropriate box to indicate your decision:</p>
            <Form.Item>
              <label>
                <div className='form-label'>Please check the appropriate box to indicate your decision:</div>
                {props.form.getFieldDecorator('rccf_consent_option', {
                  rules: [{
                    required: true,
                    message: 'Required'
                  }],
                })(
                  <Radio.Group>
                    <Radio value='stay_in_study'>
                      I wish to stay in the study.
                    </Radio>
                    <br/>
                    <Radio value='withdraw_from_study'>
                      I wish to withdraw from the study
                    </Radio>
                    <br/>
                    <Radio value='withdraw_from_study_allow_data_collection_via_linkage'>
                      I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage.
                    </Radio>
                  </Radio.Group>
                )}
              </label>
            </Form.Item>

          </div>}

          <Form.Item>
            <label>
              <div className='form-label'>Participant Name</div>
              {props.form.getFieldDecorator('rccf_participant_name', {
                initialValue: props.rccf_participant_name,
                rules: [{
                  required: true,
                  message: 'Required'
                }],
              })(
                <Input
                  prefix={<Icon type="user" style={{color: '#eee'}}/>}
                  placeholder="Participant Name"
                />
              )}
            </label>
          </Form.Item>

          {props.consentMethodType === 'EmailRegainedCapacity' && <Form.Item>
            {props.form.getFieldDecorator('sb_dic_participant_email', {
              initialValue: props.sb_dic_participant_email,
              rules: [{required: true, message: 'Please enter the participant\'s email'}, {type: 'email'}],
            })(
              <Input disabled={props.token} placeholder="Participant Email"/>
            )}
          </Form.Item>}

          {props.consentPersonType === 'Patient' && showForEmail  && (
            <div>
              <Signature fieldName='rccf_participant_signature' label='Signature of Participant' form={props.form} />
            </div>
          )}


          {!props.token && <div>
            <h4>Person Obtaining Consent</h4>
            <ul>
              <li>By signing this form, I confirm that:</li>
              <li>This study and its purpose has been explained to the participant named above</li>
              <li>All questions asked by the participant have been answered</li>
              <li>I will give a copy of this signed and dated document to the participant</li>
            </ul>
          </div>}

          <div>
            <Form.Item>
              <label>
                <div className='form-label'>Name of Person Obtaining Consent</div>
                {props.form.getFieldDecorator('rccf_investigator_name', {
                  initialValue: props.rccf_investigator_name,
                  rules: [{
                    required: true,
                    message: 'Required'
                  }],
                })(
                  <Input
                    disabled={props.token}
                    prefix={<Icon type="user" style={{color: '#eee'}}/>}
                    placeholder="Name of Person Obtaining Consent"
                  />
                )}
              </label>
            </Form.Item>

            {!props.token && <Signature fieldName='rccf_investigator_signature' label='Signature of Person Obtaining Consent' form={props.form} />}
          </div>

          {showForEmail && <Form.Item>
            <label>
              <div className='form-label'>Do you consent to the terms described above?</div>
              {props.form.getFieldDecorator('consent_provided', {
                initialValue: props.consent_provided,
                rules: [{
                  required: true,
                  message: 'Do you consent to the terms described above?'
                }],
              })(
                <Select>
                  <Option value="yes">Yes</Option>
                  <Option value="">No</Option>
                </Select>
              )}
            </label>
          </Form.Item>}

          <p>The Sunnybrook Research Ethics Board has approved this research study.</p>

        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ConsentTypeOttawa/Step3aRegainedCapacity.js